(function() {
  'use strict';

  if (window.__cardHoverSlideshowInitialized) return;
  window.__cardHoverSlideshowInitialized = true;

  var activeCard = null;
  var slideshowTimer = null;
  var SLIDE_INTERVAL = 1200; // ms between slide transitions

  function preloadImages(container) {
    if (!container) return;
    var imgs = container.querySelectorAll('.card-hover-slideshow__img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].loading === 'lazy') {
        imgs[i].loading = 'eager';
      }
      if (imgs[i].decode) {
        imgs[i].decode().catch(function() {});
      }
    }
  }

  function resetCard(card) {
    if (!card) return;
    var container = card.querySelector('[data-card-slideshow]');
    if (!container) return;

    // Apply is-resetting to suppress all transitions during layout reset
    container.classList.add('is-resetting');
    var imgs = container.querySelectorAll('.card-hover-slideshow__img');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].classList.remove('is-prev', 'is-next');
      if (i === 0) {
        imgs[i].classList.add('is-active');
      } else {
        imgs[i].classList.remove('is-active');
        if (i === 1) {
          imgs[i].classList.add('is-next');
        }
      }
    }
    // Force reflow so the reset state takes effect instantly without animation
    void container.offsetWidth;
    container.classList.remove('is-resetting');
  }

  function startSlideshow(card) {
    // Only run slideshow on desktop (width >= 750px)
    if (window.innerWidth < 750) return;

    var container = card.querySelector('[data-card-slideshow]');
    if (!container) return;

    var imgs = container.querySelectorAll('.card-hover-slideshow__img');
    if (!imgs || imgs.length < 2) return;

    activeCard = card;
    resetCard(card);
    preloadImages(container);

    if (slideshowTimer) {
      clearInterval(slideshowTimer);
      slideshowTimer = null;
    }

    var currentIndex = 0;
    slideshowTimer = setInterval(function() {
      if (!activeCard || activeCard !== card) {
        clearInterval(slideshowTimer);
        slideshowTimer = null;
        return;
      }

      var prevIndex = currentIndex;
      currentIndex++;

      if (currentIndex >= imgs.length) {
        // Stop once all available product images have been displayed
        clearInterval(slideshowTimer);
        slideshowTimer = null;
        return;
      }

      var nextIndex = (currentIndex + 1 < imgs.length) ? (currentIndex + 1) : -1;

      for (var i = 0; i < imgs.length; i++) {
        if (i === currentIndex) {
          imgs[i].classList.remove('is-prev', 'is-next');
          imgs[i].classList.add('is-active');
        } else if (i === prevIndex) {
          imgs[i].classList.remove('is-active', 'is-next');
          imgs[i].classList.add('is-prev');
        } else if (i === nextIndex) {
          imgs[i].classList.remove('is-active', 'is-prev');
          imgs[i].classList.add('is-next');
        } else {
          imgs[i].classList.remove('is-active', 'is-prev', 'is-next');
        }
      }
    }, SLIDE_INTERVAL);
  }

  function stopSlideshow(card) {
    if (slideshowTimer) {
      clearInterval(slideshowTimer);
      slideshowTimer = null;
    }
    resetCard(card);
    if (activeCard === card) {
      activeCard = null;
    }
  }

  document.addEventListener('mouseover', function(e) {
    var card = e.target.closest('.card-wrapper, .our-bestsellers__card');
    if (!card) return;
    if (card === activeCard) return;

    if (activeCard && activeCard !== card) {
      stopSlideshow(activeCard);
    }

    startSlideshow(card);
  }, { passive: true });

  document.addEventListener('mouseout', function(e) {
    if (!activeCard) return;
    var related = e.relatedTarget;
    if (related && activeCard.contains(related)) {
      return;
    }
    stopSlideshow(activeCard);
  }, { passive: true });
})();

